import React, { useState, useEffect, useContext } from "react";
import MixLogo from '../../assets/images/logo.svg';
import MobileIcon from '../../assets/images/comman/mobileNumber.png'
import AadharIcon from '../../assets/images/comman/AadharNumber.png'
import ABHANumber from '../../assets/images/comman/abhaNumber.png'
import LoginABHANumber from '../../components/Login-ABHA/LoginABHANumber';
import LoginABHAAddress from '../../components/Login-ABHA/LoginABHAAddress';
import LoginAadharNumber from '../../components/Login-ABHA/LoginAadharNumer';
import LoginMobileNumber from '../../components/Login-ABHA/LoginMobileNumer';
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { GlobalContext } from "../../GlobalDataContext/GlobalContext";


const LoginABHAPage = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const prefillAddress = searchParams.get('prefillAddress');
    
    const back = () => {
        setLoginType(0);
        navigate('/abha-home');
    }
    const { setDataByKey } = useContext(GlobalContext)
    
    // Set default login type based on whether there's a prefilled address
    const [loginType, setLoginType] = useState(prefillAddress ? 4 : 1);
    
    useEffect(() => {
        setDataByKey('backfunction', back)
        
        // If there's a prefilled address, automatically select ABHA Address login type
        if (prefillAddress) {
            setLoginType(4);
        }
    }, [prefillAddress]);
    /**
     * Function used to set otp text
     */
    const handeLoginType = (e) => {
        const value = Number(e.target.value);
        switch (value) {
            case 1:
                setLoginType(value);
                break;
            case 2:
                setLoginType(value);
                break;
            case 3:
                setLoginType(value);
                break;
            case 4:
                setLoginType(value);
                break;
            default:
                break;
        }
    };
    return (
        <>
            <div className="mainFlow">
                <div className="container">
                    <div className="pranHealtnMainUserFlow">
                        <div className="abha-paranLogo">
                            <img src={MixLogo} />
                        </div>
                        <div className="userFlowAdharVer anotherPaddingPage">
                            <div className="flowTitle">
                                <h4>View Patient ABHA</h4>
                            </div>
                            <div className='selectLoginType'>
                                <label for="mobileNumber" className={`selectTypeLogin ${loginType === 1 ? 'active-login' : ''}`}>
                                    <input type='radio' name='loginType' id='mobileNumber' onClick={handeLoginType} value={1} />
                                    <div className='loginTypeSelectOne'>
                                        <img src={MobileIcon} />
                                        <p>Mobile Number</p>
                                    </div>
                                </label>
                                <label for="aadharNumber" className={`selectTypeLogin ${loginType === 2 ? 'active-login' : ''}`}>
                                    <input type='radio' name='loginType' id='aadharNumber' onClick={handeLoginType} value={2} />
                                    <div className='loginTypeSelectOne'>
                                        <img src={AadharIcon} />
                                        <p>Aadhar Number</p>
                                    </div>
                                </label>
                                <label for="abhaNumber" className={`selectTypeLogin ${loginType === 3 ? 'active-login' : ''}`}>
                                    <input type='radio' name='loginType' id='abhaNumber' onClick={handeLoginType} value={3} />
                                    <div className='loginTypeSelectOne'>
                                        <img src={ABHANumber} />
                                        <p>ABHA Number</p>
                                    </div>
                                </label>
                                <label for="abhaAddress" className={`selectTypeLogin ${loginType === 4 ? 'active-login' : ''}`}>
                                    <input type='radio' name='loginType' id='abhaAddress' onClick={handeLoginType} value={4} />
                                    <div className='loginTypeSelectOne'>
                                        <img src={ABHANumber} />
                                        <p>ABHA Address</p>
                                    </div>
                                </label>
                            </div>
                            {loginType == 1 && (
                                <LoginMobileNumber />
                            )}
                            {loginType == 2 && (
                                <LoginAadharNumber />
                            )}
                            {loginType == 3 && (
                                <LoginABHANumber />
                            )}
                            {loginType == 4 && (
                                <LoginABHAAddress prefillAddress={prefillAddress} />
                            )}
                            <div className='loginPageFooter'>
                                <div className='forgotAbhaRetrive'>
                                    <p><Link to={'/forgoat-ABHA'}>Forgot ABHA number?</Link></p>
                                    <p><Link to={'/re-activate'}>Re-activate ABHA</Link></p>
                                    <p><Link to={'/findabha'}>Find ABHA</Link></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default LoginABHAPage;